<script setup>
import { BButton } from 'bootstrap-vue-next';
import { BAccordion, BAccordionItem } from 'bootstrap-vue-next';
import { computed } from 'vue';

const GITLAB_PROJECT_ID = 278964;

const props = defineProps({
  issues: {
    type: Array,
    required: true,
  },
});

const randomIssues = computed(() => {
  if (props.issues == null) {
    return [];
  }

  const issueList = [...props.issues];

  return issueList.sort(() => Math.random() - 0.5).slice(0, 5);
});
</script>

<template>
  <BAccordion
    class="accordion-table mb-2"
  >
    <BAccordionItem
      title="Labelathon"
      :visible="true"
    >
      <div
        v-for="(issue, index) in randomIssues"
        :key="issue.webUrl"
        class="issue-row d-flex justify-content-between align-items-center py-3 px-3 border-bottom"
        :class="{ 'even-row': index % 2 === 1 }"
      >
        <div class="flex-grow-1 me-3">
          <a
            :href="issue.webUrl"
            target="_blank"
            class="text-decoration-none fw-medium d-block text-break"
          >{{ issue.title }}</a>
        </div>
        <div class="flex-shrink-0 text-end">
          <BButton
            :to="{ name: 'manage-issue', query: { projectId: GITLAB_PROJECT_ID, issueIid: issue.iid, action: 'label', returnTo: 'labelathon' } }"
            variant="outline-primary"
            class="text-decoration-none small text-nowrap"
            size="sm"
          >
            Label issue
          </BButton>
          <BButton
            :to="{ name: 'manage-issue', query: { projectId: GITLAB_PROJECT_ID, issueIid: issue.iid, action: 'close', returnTo: 'labelathon' } }"
            variant="outline-secondary"
            class="text-decoration-none small text-nowrap"
            size="sm ms-2"
          >
            Close issue
          </BButton>
        </div>
      </div>
    </BAccordionItem>
  </BAccordion>
</template>
